<template>
  <div>
      <!-- <mheader></mheader> -->
      <div style="width:1300px;margin:0 auto;" id="v-content" :style="{minHeight:Height+'px'}">       
              <!-- 表单内容 -->
         <div class="card mb-5" style="box-shadow: 10px 10px 5px #888888;">   
             <p class="mt-2 mb-3 font">
                <img src="../../static/images/kucun.png" style="width:1.5rem;height:1.5rem;" class="mb-lg-1" alt=""/>
               <span class="p-1" style="text-shadow:#000 1px 0 0;background-color:#3190e8;color:#fff;box-shadow: 6px 4px 9px #888888;font-family: Helvetica Neue,Tahoma,Arial;border-radius:5px;">
                  药品查询
               </span>
               </p>
                <div class="row m-0 mb-3">
                        <input type="text" class="form-control w-25 ml-lg-5" placeholder="请填入药品名称/产地/规格" v-model="searchForm.searchKey">
                        <button class="btn btn-primary font ml-lg-2" @click="Search()">查询</button>
                </div>
           <table v-if="searchData.length>0"  class="table table-striped table-hover" ref="print">
               <thead>
                    <tr style="white-space: nowrap;">
                    <th>药品名称</th>
                        <th>产地名称</th>
                        <th>规格</th>
                        <th>包装</th>
                        <th>中包装</th>
                        <th>零/整</th>
                        <th>库存</th>
                        <th>价格</th>
                        <th>单位</th>
                        <th>批准文号</th>
                        <!-- <th>批号</th> -->
                        <th>生产日期</th>
                        <th>有效期</th>
                        <th>国家零售价</th>
                  </tr>
               </thead>
               <tbody>
                    <tr v-for="(item,index) in searchData" :key="index">
                              <td @dblclick="onInputdrugName(index)">{{item.ypmc}}</td>
                              <td @dblclick="onInputcustomerName(index)">{{item.cdmc}}</td>
                              <td>{{item.gg}}</td>
                              <td>{{item.bz}}</td>
                              <td>{{item.zbz}}</td>
                              <td>{{item.isretail | change}}</td>
                              <td>{{item.sl}}</td>
                              <td>{{item.dj}}</td>
                              <td>{{item.dw}}</td>
                              <td>{{item.pzwh}}</td>
                              <!-- <td>{{item.ph}}</td> -->
                              <td>{{item.scrq}}</td>
                              <td>{{item.yxq}}</td>
                              <td>{{item.lsj}}</td>
                  </tr>
               </tbody>
            </table>
            <table class="table table-striped table-hover" ref="print" v-else>
                    <thead>
                      <tr style="white-space: nowrap;">
                        <th>药品名称</th>
                        <th>产地名称</th>
                        <th>规格</th>
                        <th>包装</th>
                        <th>中包装</th>
                        <th>零/整</th>
                        <th>库存</th>
                        <th>价格</th>
                        <th>单位</th>
                        <th>批准文号</th>
                        <!-- <th>批号</th> -->
                        <th>生产日期</th>
                        <th>有效期</th>
                        <th>国家零售价</th>
                      </tr>
                    </thead>
                    <tbody>
                      <tr v-for="(item,index) in tableData" :key="index">
                              <td @dblclick="onInputdrugName(index)">{{item.ypmc}}</td>
                              <td @dblclick="onInputcustomerName(index)">{{item.cdmc}}</td>
                              <td>{{item.gg}}</td>
                              <td>{{item.bz}}</td>
                              <td>{{item.zbz}}</td>
                              <td>{{item.isretail | change}}</td>
                              <td>{{item.sl}}</td>
                              <td>{{item.dj}}</td>
                              <td>{{item.dw}}</td>
                              <td>{{item.pzwh}}</td>
                              <!-- <td>{{item.ph}}</td> -->
                              <td>{{item.scrq}}</td>
                              <td>{{item.yxq}}</td>
                              <td>{{item.lsj}}</td>
                      </tr>
                    </tbody>
                  </table>
                  <!-- 分页 -->
    <nav aria-label="Page navigation" style="text-align:center;" class="mb-1">
      <ul class="pagination">
        <li class="page-item ml-5" :class="PageNo<=1?'disabled':''" @click="prePage()">
          <a aria-label="Previous" class="page-link">
            <span aria-hidden="true">&laquo;</span>
          </a>
        </li>
            <li :class="index==PageNo?'active':''" class="page-item" v-for="index of Pcount" :key="index"
                                                @click="curPage(index)">
                                                <a class="page-link" v-if="index<=20">{{index}}</a>
                                                <a class="page-link" v-if="index>20 && index==(Pcount-1)">...</a>
                                                <a class="page-link" v-if="index>20 && index==Pcount">{{Pcount}}</a>
                                            </li>
        <li class="page-item" :class="PageNo>=Pcount?'disabled':''" @click="nextPage()">
          <a aria-label="Next" class="page-link" >
            <span aria-hidden="true">&raquo;</span>
          </a>
        </li>
          <li class="ml-5">
            <span class="d-block mt-2">
              总共有
              <span style="color:green;font-size:20px">{{Record}}</span>
              条数据
            </span>
          </li>
      </ul>
    </nav>
  </div> 
    
       <!-- container -->   
      </div>
                <div>
                  <transition name="fade">
                           <loading v-if="isLoading">        
                           </loading>
                  </transition>
                </div>
  <!-- Footer -->
         <!-- <mfooter></mfooter> -->
     </div>
</template>
<script>
// import mheader from '../components/Header.vue'
// import mfooter from '../components/Footer.vue'
import Loading from '../components/Loading.vue'
import { async } from 'q';
export default {
      name: 'DrugQuery',
    data () {
      return {
         Height:0,
        searchForm: {
         searchKey:'',
        },//搜索内容
        searchData:[],//搜索返回的清单
        isLoading: true,
        tableData: [],
        Record:'',//总记录数
        Pcount:'',//总页数
        PageNo:1, //当前页码
      
      }
    },
    components:{
        // mheader,
        // mfooter,
        Loading
    },
    computed:{
         
},
filters: {
    change(data){
         if(data==1){
           return "零"
         }else{
           return '整'
         }
    }
},

methods: {
      searchEnterFun(e){
         var keyCode = window.event ? e.keyCode : e.which;
         if(keyCode == 13){
           this.Search();
         }
      },
      
      onInputdrugName:function(index){
          if(this.searchData.length>0){
            this.searchForm.searchKey=this.searchData[index].ypmc;
          }
          else {
            this.searchForm.searchKey=this.tableData[index].ypmc;
          }
      },
      onInputcustomerName:function(index){
          if(this.searchData.length>0)
          {
             this.searchForm.searchKey=this.searchData[index].cdmc
          }
          else
          {
            this.searchForm.searchKey=this.tableData[index].cdmc;
          }  
      },
      getClerkDrugQuery: async function (PageIndex) {
          this.isLoading=true;
          this.PageNo=PageIndex || this.PageNo
        const { data: res } = await this.$http.post('Dls/getFun', {
          action: 'ClerkDrugQuery',
          obj: JSON.stringify({
             SearchKey:'amxl',
             PageIndex
          })
        })
        // console.log(res)
           if(res.isok){
               const obj=res.data
                this.tableData = obj.rows
                this.Pcount = obj.record
                this.Record = obj.pcount
                this.isLoading=false
           }
      },
      
      //搜索
        Search: async function (PageIndex) {    
        const that = this
        // console.log(that.searchForm.searchKey)
        // search 是 v-model="search" 的 search
          that.isLoading=true;
        //这里加表单验证，这块就不用我说了吧
        //假设表单验证通过，这时候就可以ajax提交表单
         if(!PageIndex){PageIndex=1}
        that.PageNo = PageIndex || that.PageNo
        const {data: res} = await this.$http.post('Dls/getFun', {
          action: 'ClerkDrugQuery',
          obj: JSON.stringify({
            PageIndex,
            SearchKey:that.searchForm.searchKey,
          })
        })
        // console.log(res)
        if(res.isok){
              const obj = res.data
              that.searchData = obj.rows
              that.Pcount = obj.record
              that.Record = obj.pcount
              that.isLoading=false;
              if(obj.pcount==0){
                    alert('没有符合条件的信息')
                     that.getClerkDrugQuery();   
              }
              
        }

        },

     curPage: function (index) {
         if(this.searchData.length>0){
            this.Search(index)
         }
         else{
           this.getClerkDrugQuery(index)
         }
      },
      //上一页
      prePage: function () {
        if (this.PageNo > 1) {
          this.PageNo--;
           if(this.searchData.length>0){
            this.Search(this.PageNo)
          }
          else{
            this.getClerkDrugQuery(this.PageNo);
          }
        }
      },
      //下一页
      nextPage: function () {
        if (this.PageNo < this.Pcount) {
          this.PageNo++;
          if(this.searchData.length>0){
            this.Search(this.PageNo)
          }
          else{
            this.getClerkDrugQuery(this.PageNo);
          }
        }
      },
    
    },
     mounted(){
          //动态设置内容高度 让footer始终居底   header+footer的高度是100
    this.Height = document.documentElement.clientHeight - 100;  
　　//监听浏览器窗口变化　
    window.onresize = ()=> {this.Height = document.documentElement.clientHeight -100}
  
    },
     created () {
         this.getClerkDrugQuery();   
        
    }
}
</script>
<style scoped>
   .table-hover>tbody>tr:hover {
    background-color:#dee2e6!important;
}
.font{
  font-size:15px;
}
.font_yz{
  font-size:1px;
  color:red;
}
.button_zi{
      text-shadow:#000 1px 0 0;
      border-radius: 5px;
      border:none;
      color:azure;
  }
  .heit{
    height:1.5rem;
  }
</style>



// WEBPACK FOOTER //
// src/pages/Query.vue